import { countActiveEnvironmentFilters } from './countActiveEnvironmentFilters';
import { countActiveProjectFilters } from './countActiveProjectFilters';
import { type UIFlagFilter } from './types';

export function hasActiveFilters(filters: UIFlagFilter | undefined) {
  return countActiveProjectFilters(filters) > 0 || countActiveEnvironmentFilters(filters) > 0 || !!filters?.query;
}
